import { create } from 'zustand';

export interface IUserNotificationStoreType {
  notificationCount: number;
  updateNotificationCount: (x: number) => void;
}

export const useNotificationStore = create<IUserNotificationStoreType>((set) => ({
  notificationCount: 0,
  updateNotificationCount: (x: number) => set(() => ({ notificationCount: x })),
}));

export default useNotificationStore;
